import { ROLE_GROUPS, ROLES } from '@moal/api'
import PropTypes from 'prop-types'
import { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { AuthenticationContext } from '../context/authenticationContext'

export const hasStaffPrivilege = (user, viporbot = false) => {
  const role = user?.role?.role
  if (!role) return false

  const allowed = viporbot
    ? [...ROLE_GROUPS.STAFF, ROLES.VIP, ROLES.BOT]
    : ROLE_GROUPS.STAFF

  return allowed.includes(role)
}

const RequireRole = ({ role, children }) => {
  const { user } = useContext(AuthenticationContext)

  if (!user || !user.role.role) {
    return <Navigate to="/" />
  }

  switch (role) {
    case ROLES.ADMIN:
      if (user.role.role !== ROLES.ADMIN) {
        return <Navigate to="/" />
      }
      break
    case 'staff':
    default:
      if (!hasStaffPrivilege(user)) {
        return <Navigate to="/" />
      }

      break
  }

  return children
}

RequireRole.propTypes = {
  role: PropTypes.string,
  children: PropTypes.object
}

export default RequireRole
